"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReceiptLines = exports.getTotalLine = exports.getCouponsListLines = exports.getEntrepriseDiscountLine = exports.getShippingCostLine = exports.getLinkedOrderLine = exports.getCompletionOrderLine = exports.getOrderLine = void 0;
var OrderPrices_1 = require("./OrderPrices");
var Formatting_1 = require("../../Formatting");
var CouponWordings_1 = require("../Coupon/CouponWordings");
var getOrderLine = function (order) {
    var _a;
    return (order ? {
        label: 'Votre commande',
        value: "".concat((0, Formatting_1.formatPrice)((_a = (0, OrderPrices_1.getOrderPrice)(order)) === null || _a === void 0 ? void 0 : _a.subTotal)),
    } : null);
};
exports.getOrderLine = getOrderLine;
var getCompletionOrderLine = function (order) {
    var _a;
    return (order ? {
        label: 'Votre panier en cours',
        value: "".concat((0, Formatting_1.formatPrice)((_a = (0, OrderPrices_1.getOrderPrice)(order)) === null || _a === void 0 ? void 0 : _a.subTotal)),
    } : null);
};
exports.getCompletionOrderLine = getCompletionOrderLine;
var getLinkedOrderLine = function (order) {
    var _a;
    return (order ? {
        label: 'Votre commande en cours',
        value: "".concat((0, Formatting_1.formatPrice)((_a = (0, OrderPrices_1.getOrderPrice)(order)) === null || _a === void 0 ? void 0 : _a.subTotal)),
    } : null);
};
exports.getLinkedOrderLine = getLinkedOrderLine;
var getShippingCostLine = function (order) {
    var _a;
    var cost = (_a = (0, OrderPrices_1.getOrderPrice)(order)) === null || _a === void 0 ? void 0 : _a.shippingCost;
    return {
        label: 'Livraison',
        value: (0, Formatting_1.formatPrice)(cost, { freeString: 'Offerte' }),
        type: !parseFloat(cost) ? 'discount' : undefined,
    };
};
exports.getShippingCostLine = getShippingCostLine;
var getEntrepriseDiscountLine = function (order) {
    var _a;
    var discount = parseFloat((_a = (0, OrderPrices_1.getOrderPrice)(order)) === null || _a === void 0 ? void 0 : _a.enterpriseDiscount);
    return discount !== 0 ? {
        label: 'Remise entreprise',
        value: "-".concat((0, Formatting_1.formatPrice)(discount)),
        type: 'discount',
    } : null;
};
exports.getEntrepriseDiscountLine = getEntrepriseDiscountLine;
var getCouponsListLines = function (order) {
    return order.coupons
        .map(function (coupon) { return ({
        label: coupon.couponCode,
        value: (0, CouponWordings_1.getCouponUnit)(coupon, { showMinus: true }),
        type: 'discount',
    }); });
};
exports.getCouponsListLines = getCouponsListLines;
var getTotalLine = function (order) {
    var _a;
    return {
        label: 'Total',
        value: "".concat((0, Formatting_1.formatPrice)((_a = (0, OrderPrices_1.getOrderPrice)(order)) === null || _a === void 0 ? void 0 : _a.total)),
        type: 'total',
    };
};
exports.getTotalLine = getTotalLine;
var getReceiptLines = function (order, _a) {
    var _b = _a === void 0 ? {} : _a, linkedOrder = _b.linkedOrder, completionOrder = _b.completionOrder, _c = _b.showCoupons, showCoupons = _c === void 0 ? false : _c;
    if (!order)
        return [];
    var lines = linkedOrder && completionOrder
        ? [(0, exports.getCompletionOrderLine)(completionOrder), (0, exports.getLinkedOrderLine)(linkedOrder)]
        : [(0, exports.getOrderLine)(order)];
    return __spreadArray(__spreadArray(__spreadArray([], lines, true), (showCoupons ? (0, exports.getCouponsListLines)(order) : []), true), [
        (0, exports.getShippingCostLine)(order),
        (0, exports.getEntrepriseDiscountLine)(order)
    ], false).filter(Boolean);
};
exports.getReceiptLines = getReceiptLines;
//# sourceMappingURL=OrderReceiptDetails.js.map